/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from "@wordpress/i18n";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
	useBlockProps,
	InspectorControls,
	PanelColorSettings,

} from "@wordpress/block-editor";
import {
	Button,
	PanelBody,
	SelectControl,
	RangeControl
} from "@wordpress/components";
import { Fragment, useEffect } from "@wordpress/element";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { loaderBackground, loaderColor, loaders, borderRadius, loaderSize, loadingTime, spinnerWidth } = attributes

	// function to convert HEX to RGB
	const hexToRgb = (hex) => {
		if (!hex || hex[0] !== "#" || (hex.length !== 7 && hex.length !== 4)) {
			return "246, 207, 244";
		}

		let r, g, b;

		if (hex.length === 7) { // #RRGGBB format
			r = parseInt(hex.slice(1, 3), 16);
			g = parseInt(hex.slice(3, 5), 16);
			b = parseInt(hex.slice(5, 7), 16);
		} else { // #RGB format
			r = parseInt(hex[1] + hex[1], 16);
			g = parseInt(hex[2] + hex[2], 16);
			b = parseInt(hex[3] + hex[3], 16);
		}

		return `${r}, ${g}, ${b}`;
	};

	const getStyles = () => ({
		'--loader-background-color': loaderBackground,
		'--loader-color': loaderColor,
		'--loader-size': `${loaderSize}px`,
		'--loader-radius': `${borderRadius}%`,
		'--spinner-width': `${spinnerWidth}px`,
		'--loader-rgb': hexToRgb(loaderColor)
	});

	const loaderOption = [
		{ label: "Dots", value: "dots" },
		{ label: "Spinner", value: "spinning" },
		{ label: "The Bars", value: "bar" },
	];

	useEffect(() => {
		if (["inwardSpiral", "rotatingElement"].includes(loaders)) {
			setAttributes({ showoption: true });
		}
	}, [loaders, setAttributes]);;

	return (
		<div {...useBlockProps()}>
			<InspectorControls>
				<PanelBody
					title={__("Loader Settings", "templazee")}
					initialOpen={true}
				>
					<SelectControl
						label={__("Choose Loader", "templazee")}
						value={loaders}
						options={loaderOption}
						onChange={(newLoader) => setAttributes({ loaders: newLoader })}
					/>
					<PanelColorSettings
						title={__("Color Settings", "templazee")}
						colorSettings={[
							{
								value: loaderBackground,
								onChange: (color) => setAttributes({ loaderBackground: color }),
								label: __("Loader Background Color", "templazee"),
							},
							{
								value: loaderColor,
								onChange: (color) => setAttributes({ loaderColor: color }),
								label: __("Loader Color", "templazee"),
							}
						]}
					/>
					<RangeControl
						label={__("Loader Size", "templazee")}
						value={loaderSize}
						onChange={(value) => setAttributes({ loaderSize: value })}
						min={5}
						max={250}
					/>
					{!["rotatingElement", "dots"].includes(loaders) || (
						<>
							<RangeControl
								label={__("Border Radius", "templazee")}
								value={borderRadius}
								onChange={(value) => setAttributes({ borderRadius: value })}
								min={0}
								max={100}
							/>
						</>
					)}
					{!["spinning"].includes(loaders) || (
						<>
							<RangeControl
								label={__("Spinner Width", "templazee")}
								value={spinnerWidth}
								onChange={(value) => setAttributes({ spinnerWidth: value })}
								min={1}
								max={50}
							/>
						</>
					)}
					<RangeControl
						label={__("Page Load Time (in seconds)", "templazee")}
						value={loadingTime}
						onChange={(value) => setAttributes({ loadingTime: value })}
						min={1}
						max={10}
					/>

				</PanelBody>
			</InspectorControls>
			<div className="">Loader Preview</div>
			<div className={`templazee loader-display`} style={getStyles()}>
				<div className={`loader-animation ${loaders || 'inwardSpiral'}`}>
				</div>
			</div>
		</div>
	);
}

